// class ProductListSlider extends HTMLElement {
//   connectedCallback() {
//     this.initSlider();
//   }

//   initSlider() {
//     const loopEnabled     = this.dataset.loop === "true";
//     const progressEnabled = this.dataset.progressBar === "true";
//     const centerMode      = this.dataset.centerMode === "true";
//     const desktopRow      = parseFloat(this.dataset.desktopRow) || 4;
//     const mobileRow       = parseFloat(this.dataset.mobileRow)  || 1;

//     const spaceBetween = 32; 
//     const isMobile = window.matchMedia("(max-width: 768px)").matches;

//     let finalLoop = loopEnabled;
//     let finalCenterMode = centerMode;

//     const totalSlides = this.querySelectorAll(".swiper-slide").length;
//     const slidesNeeded = isMobile ? 2 : desktopRow;

//     // Disable loop if slides are less
//     if (totalSlides < slidesNeeded) {
//       finalLoop = false;
//     }

//     // ★ NEW RULE: On mobile remove loop + center mode if progress bar is active
//     if (isMobile && progressEnabled) {
//       finalLoop = false;
//       finalCenterMode = false;
//     }

//     console.log("finalLoop", finalLoop);
//     console.log("finalCenterMode", finalCenterMode);

//     const section = this.closest(".shopify-section");
//     const sectionId = section?.id?.replace("shopify-section-", "");

//     const paginationEl = section?.querySelector(`.swiper-pagination-${sectionId}`);
//     const nextBtn      = section?.querySelector(`.swiper-button-next-${sectionId}`);
//     const prevBtn      = section?.querySelector(`.swiper-button-prev-${sectionId}`);

//     const swiperConfig = {
//       slidesPerView: mobileRow,
//       spaceBetween: 0,
//       loop: finalLoop,
//       centeredSlides: finalCenterMode,
//       slidesPerGroup: 1,

//       breakpoints: {
//         768: {
//           slidesPerView: desktopRow,
//           spaceBetween,
//           centeredSlides: centerMode, // desktop original value
//         }
//       }
//     };

//     if (progressEnabled && paginationEl) {
//       swiperConfig.pagination = {
//         centeredSlides: false,
//         el: paginationEl,
//         type: "progressbar",
//       };
//     }

//     if (nextBtn && prevBtn) {
//       swiperConfig.navigation = {
//         nextEl: nextBtn,
//         prevEl: prevBtn
//       };
//     }

//     this.swiper = new Swiper(this, swiperConfig);
//   }
// }

// customElements.define("product-list-slider", ProductListSlider);

// class VideoShopSlider extends HTMLElement {
//   connectedCallback() {
//     this.initSlider();
//     this.setupResizeListener();
//   }

//   setupResizeListener() {
//     let resizeTimeout;
//     window.addEventListener("resize", () => {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(() => {
//         this.reInitSlider();
//       }, 200);
//     });
//   }

//   reInitSlider() {
//     if (this.swiper) {
//       this.swiper.destroy(true, true);
//     }
//     this.initSlider();
//   }

//   initSlider() {
//     const isMobileSmall = window.matchMedia("(max-width: 574px)").matches;
//     const isMobileMedium = window.matchMedia("(min-width: 575px) and (max-width: 768px)").matches;
//     const isTablet = window.matchMedia("(min-width: 769px) and (max-width: 1024px)").matches;

//     // Loop / Center rules
//     let finalLoop = true;
//     let finalCenterMode = true;

//     // Progress bar for both small and medium mobile
//     let finalProgressBar = isMobileSmall || isMobileMedium;

//     // Remove old pagination
//     const oldPagination = this.querySelector(".swiper-pagination");
//     if (oldPagination) oldPagination.remove();

//     // Slides count
//     const totalSlides = this.querySelectorAll(".swiper-slide").length;
//     if (totalSlides < 2) finalLoop = false;

//     // Create pagination element
//     let paginationEl = null;
//     if (finalProgressBar) {
//       paginationEl = document.createElement("div");
//       paginationEl.className = "swiper-pagination";
//       this.appendChild(paginationEl);
//     }

//     // Default desktop settings
//     let slidesPerView = 4.232;
//     let spaceBetween = 16;

//     // Mobile Small (0–574px) → 1.5
//     if (isMobileSmall) {
//       slidesPerView = 1.377;
//       spaceBetween = 12;
//     }

//     // Mobile Medium (575–768px) → 2
//     if (isMobileMedium) {
//       slidesPerView = 2.5;
//       spaceBetween = 12;
//     }

//     // Tablet (769–1024px) → 3.5
//     if (isTablet) {
//       slidesPerView = 3.5;
//       spaceBetween = 12;
//     }

//     const swiperConfig = {
//       slidesPerView,
//       spaceBetween,
//       loop: finalLoop,
//       centeredSlides: finalCenterMode,
//       slidesPerGroup: 1,
//     };

//     if (finalProgressBar && paginationEl) {
//       swiperConfig.pagination = {
//         el: paginationEl,
//         type: "progressbar",
//       };
//     }

//     this.swiper = new Swiper(this, swiperConfig);
//   }
// }

// customElements.define("video-shop-slider", VideoShopSlider);

// class BundleSlider extends HTMLElement {
//   connectedCallback() {
//     this.initSlider();
//     this.setupResizeListener();
//   }

//   setupResizeListener() {
//     let resizeTimeout;
//     window.addEventListener("resize", () => {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(() => {
//         this.reInitSlider();
//       }, 200);
//     });
//   }

//   reInitSlider() {
//     if (this.swiper) {
//       this.swiper.destroy(true, true);
//     }
//     this.initSlider();
//   }

//   initSlider() {
//     const isMobileSmall = window.matchMedia("(max-width: 574px)").matches;
//     const isMobileMedium = window.matchMedia("(min-width: 575px) and (max-width: 768px)").matches;
//     const isTablet = window.matchMedia("(min-width: 769px) and (max-width: 1024px)").matches;

//     // Loop / Center rules
//     let finalLoop = true;
//     let finalCenterMode = true;

//     // Slides count
//     const totalSlides = this.querySelectorAll(".swiper-slide").length;
//     if (totalSlides < 2) finalLoop = false;


//     // Default desktop settings
//     let slidesPerView = 4.8;
//     let spaceBetween = 0;

//     // Mobile Small (0–574px) → 1.5
//     if (isMobileSmall) {
//       slidesPerView = 2.4;
//       spaceBetween = 0;
//     }

//     // Mobile Medium (575–768px) → 2
//     if (isMobileMedium) {
//       slidesPerView = 3.5;
//       spaceBetween = 0;
//     }

//     // Tablet (769–1024px) → 3.5
//     if (isTablet) {
//       slidesPerView = 4;
//       spaceBetween = 0;
//     }

//     const swiperConfig = {
//       slidesPerView,
//       spaceBetween,
//       loop: finalLoop,
//       centeredSlides: finalCenterMode,
//       slidesPerGroup: 1,
//     };

//     this.swiper = new Swiper(this, swiperConfig);
//   }
// }

// customElements.define("bundle-slider", BundleSlider);

class CustomSlider extends HTMLElement {
  connectedCallback() {
    this.initSlider();
    this.attachResize();
  }

  attachResize() {
    let timer;
    window.addEventListener("resize", () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.reInit(), 200);
    });
  }

  reInit() {
    if (this.swiper) this.swiper.destroy(true, true);
    this.initSlider();
  }

  initSlider() {
    const loopAttr          = this.dataset.loop === "true";
    const centerAttr        = this.dataset.center === "true";
    const mobileCenterAttr  = this.dataset.mobileCenter === "true";
    const progressAttr      = this.dataset.progress === "true";

    const isMobileSmall  = window.matchMedia("(max-width: 574px)").matches;
    const isMobileMedium = window.matchMedia("(min-width: 575px) and (max-width: 768px)").matches;
    const isMobile       = isMobileSmall || isMobileMedium;

    const mobileSmallView   = parseFloat(this.dataset.mobileSmall)  || 1.5;
    const mobileMediumView  = parseFloat(this.dataset.mobileMedium) || 2;
    const tabletView        = parseFloat(this.dataset.tablet)       || 3.5;
    const desktopView       = parseFloat(this.dataset.desktop)      || 4;

    const mobileSmallSpace  = parseFloat(this.dataset.spaceSmall)   || 0;
    const mobileMediumSpace = parseFloat(this.dataset.spaceMedium)  || 0;
    const tabletSpace       = parseFloat(this.dataset.spaceTablet)  || 0;
    const desktopSpace      = parseFloat(this.dataset.spaceDesktop) || 0;

    let slidesPerView = desktopView;
    let spaceBetween  = desktopSpace;

    if (isMobileSmall) {
      slidesPerView = mobileSmallView;
      spaceBetween  = mobileSmallSpace;
    } else if (isMobileMedium) {
      slidesPerView = mobileMediumView;
      spaceBetween  = mobileMediumSpace;
    } else if (window.matchMedia("(min-width: 769px) and (max-width: 1024px)").matches) {
      slidesPerView = tabletView;
      spaceBetween  = tabletSpace;
    }

    const breakInMobile = this.dataset.breakInMobile === "true";
    const isBreakPoint = window.innerWidth <= 1149;

    if (breakInMobile && isBreakPoint) {
      if (this.swiper) this.swiper.destroy(true, true);

      this.classList.add("break-slider");
      this.style.display = "flex";
      this.style.gap = spaceBetween + "px";

      return; 
    }

    const totalSlides = this.querySelectorAll(".swiper-slide").length;
    let finalLoop = loopAttr;
    let final_slides = Math.ceil((slidesPerView * 2) - 1);

    if (finalLoop && totalSlides < final_slides) {
      finalLoop = false; 
    }

    let finalCenter = centerAttr;
    if (isMobile && this.dataset.mobileCenter !== undefined) {
      finalCenter = mobileCenterAttr;
    }

    if(totalSlides <= slidesPerView) {
      finalCenter = false;
    }

    // PROGRESS BAR (MOBILE ONLY)
    let paginationEl = this.querySelector(".swiper-pagination");
    if (paginationEl) paginationEl.remove(); // remove old

    const isQuickBuy = this.closest(".quick-buy-drawer__variant") !== null;
    const showProgressMobile = progressAttr && (isMobile || isQuickBuy);

    const autoplayAttr = this.dataset.autoplay === "true";

    // SWIPER CONFIG
    const swiperConfig = {
      slidesPerView,
      spaceBetween,
      loop: finalLoop,
      centeredSlides: finalCenter,
      slidesPerGroup: 1,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 0.3,       
        releaseOnEdges: true,
        thresholdDelta: 20,     
        thresholdTime: 100     
      }
    };

    if (autoplayAttr) {
      swiperConfig.autoplay = {
        delay: parseInt(this.dataset.autoplayDelay) || 3000,
        disableOnInteraction: false
      };
    }  
  

    this.swiper = new Swiper(this, swiperConfig);

    if (showProgressMobile) {
      this.createProgressBar();
      this.updateProgressBar();
      this.bindProgressEvents();
    }
  }

  createProgressBar() {
    this.querySelector(".swiper-progress-bar")?.remove();
    const bar = document.createElement("div");
    bar.className = "swiper-progress-bar";

    const progress = document.createElement("div");
    progress.className = "progress";

    bar.appendChild(progress);
    this.appendChild(bar);
  }

  updateProgressBar() {
    const progress = this.querySelector(".swiper-progress-bar .progress");

    const slidesCount = this.swiper.params.loop
      ? this.swiper.slides.length
      : this.swiper.slides.length;

    const index = this.swiper.realIndex + 1;
    const percent = (index / slidesCount) * 100;

    console.log("slidesCount000", slidesCount, index, this.swiper, this)

    progress.style.width = `${percent}%`;
  }

  bindProgressEvents() {
    const progress = this.querySelector(".swiper-progress-bar .progress");

    this.swiper.on("slideChange", () => {
      progress.style.transition = `width ${this.swiper.params.speed}ms linear`;
      this.updateProgressBar();
    });

    this.swiper.on("touchStart", () => {
      progress.style.transition = "none";
    });
  }

}

customElements.define("custom-slider", CustomSlider);

document.addEventListener('DOMContentLoaded', () => {
  function handleAccordionEffect() {
    const footerMenu = document.querySelector('.footer__block--menu:last-child');
    
    if (footerMenu && window.innerWidth <= 700) {
      const footerHeading = footerMenu.querySelector('.footer--block-heading');
      const nextElement = footerMenu.querySelector('ul');
      
      footerHeading.addEventListener('click', () => { 
        if (nextElement) {
          const scrollHeight = nextElement.scrollHeight;
          
          if (nextElement.style.maxHeight && nextElement.style.maxHeight !== '0px') {
            nextElement.style.maxHeight = '0px';
            footerMenu.classList.remove('active'); // Collapse
          } else {
            nextElement.style.maxHeight = `${scrollHeight}px`;
            footerMenu.classList.add('active'); // Expand
          }
          
        }
      });
    }
  }

  // Initially run the accordion function on page load
  handleAccordionEffect();

  // Optional: Re-run when resizing the window (to ensure it works when resizing above 700px)
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 700) {
      handleAccordionEffect();
    }
  });
});


// document.addEventListener("DOMContentLoaded", () => {
//   const rows = document.querySelectorAll("[data-bundle-row]");
//   const totalEl = document.getElementById("bundle-total");

//   function updateTotal() {
//     let total = 0;

//     rows.forEach(row => {
//       const input = row.querySelector("[data-input]");
//       total += Number(input.value || 0);
//     });

//     if(totalEl) {

//       totalEl.textContent = total;
//     }
//   }
//   console.log("rows-", rows)

//   rows.forEach(row => {
//     const input = row.querySelector("[data-input]");
//     const plus = row.querySelector("[data-plus]");
//     const minus = row.querySelector("[data-minus]");
//     // Manual typing
//     input.addEventListener("change", updateTotal);
//   });

//   updateTotal();
// });

// class BundleContainer extends HTMLElement {
//   constructor() {
//     super(); // optional: for encapsulated styles
//   }

//   connectedCallback() {
//     console.log("bundle init");
//     const rows = this.querySelectorAll("[data-bundle-row]");
//     const totalEl = this.querySelector("[data-bundle-total]");
//     const maxTotal = Number(this.getAttribute("data-max") || Infinity);

//     const updateTotal = () => {
//       const productContainer = this.closest("product-rerender");
//       const submitBtn = productContainer?.querySelector(".buy-buttons [type='submit']");

//       let total = 0;

//       rows.forEach(row => {
//         const input = row.querySelector("[data-input]");
//         total += Number(input?.value || 0);
//       });

//       if (totalEl) totalEl.textContent = total;

//       // Plus button logic
//       const plusButtons = this.querySelectorAll("[data-plus]");
//       plusButtons.forEach(btn => {
//         if (total >= maxTotal) {
//           btn.disabled = true;
//         } else {
//           const row = btn.closest("[data-bundle-row]");
//           const input = row?.querySelector("[data-input]");
//           const itemValue = Number(input?.value || 0);
//           const itemMax = Number(input?.getAttribute("max") ?? Infinity);
//           btn.disabled = itemValue >= itemMax;
//         }
//       });

//       if (submitBtn) {
//         submitBtn.disabled = total < maxTotal;
//       }
//     };
//     rows.forEach(row => {
//       const input = row.querySelector("[data-input]");
//       const plus = row.querySelector("[data-plus]");
//       const minus = row.querySelector("[data-minus]");

//       input?.addEventListener("input", updateTotal);

//       plus?.addEventListener("click", updateTotal);
//       minus?.addEventListener("click", updateTotal);
//     });

//     updateTotal();

//     const form = document.querySelector("form[is='product-form']");

//     if (!form) {
//       console.log("Product form not found");
//       return;
//     }

//     // capture phase = highest priority (beats Shopify handler)
//     form.addEventListener(
//       "submit",
//       this.handleBundleSubmit.bind(this),
//       true
//     );

//     console.log("Bundle submit listener attached");
//   }

//   async handleBundleSubmit(event) {
//     event.preventDefault();
//     event.stopImmediatePropagation();

//     const items = [];
//     this.querySelectorAll("[data-bundle-row]").forEach((row) => {
//       const qtyInput = row.querySelector("[data-input]");
//       console.log("qtyInputqtyInput00", qtyInput);
//       const variantInput = row.querySelector("[data-input-id]");

//       const quantity = Number(qtyInput?.value || 0);
//       const variantId = Number(variantInput?.value);

//       if (quantity > 0 && variantId) {
//         items.push({ id: variantId, quantity });
//       }
//     });

//     console.log("items:", items);

//     if (!items.length) return;

//     const productContainer = this.closest("product-rerender");
//     const submitBtn = productContainer?.querySelector(".buy-buttons [type='submit']");

//     try {
//       if (submitBtn) {
//         submitBtn.setAttribute("aria-busy", "true");
//         submitBtn.disabled = true;
//       }

//       const res = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ items })
//       });

//       const data = await res.json();

//       document.documentElement.dispatchEvent(
//         new CustomEvent("cart:refresh", { bubbles: true })
//       );

//     } catch (e) {
//       console.error(e);

//     } finally {
//       if (submitBtn) {
//         submitBtn.removeAttribute("aria-busy");
//         submitBtn.disabled = false;
//       }

      
//       setTimeout(() => {
//         if (typeof handleFloCartBtn === "function") {
//           handleFloCartBtn();
//         }

//         document.documentElement.dispatchEvent(
//           new CustomEvent("cart:refresh", { bubbles: true })
//         );
//       }, 2000);
//     }
//   }

//   disconnectedCallback() {
//     this.removeEventListener("click", this._onClick);

//     const form = document.querySelector("form[is='product-form']");

//     form.removeEventListener(
//       "submit",
//       this.handleBundleSubmit.bind(this),
//       true
//     );
//     this.rows?.forEach(row => {
//       const input = row.querySelector("[data-input]");
//       const plus = row.querySelector("[data-plus]");
//       const minus = row.querySelector("[data-minus]");
//       input?.removeEventListener("change", this._onChange);
//       plus?.removeEventListener("click", this._onClick);
//       minus?.removeEventListener("click", this._onClick);
//     });
//   }
// }

// // Define the custom element
// customElements.define("bundle-container", BundleContainer);

class BundleContainer extends HTMLElement {
  constructor() {
    super();
    this._updateTotal = this._updateTotal.bind(this);
    this._handleBundleSubmit = this.handleBundleSubmit.bind(this);
  }

  connectedCallback() {
    console.log("bundle init");

    // ✅ Single delegated listener on the container — survives DOM refreshes
    this.addEventListener("click", this._onDelegatedClick.bind(this));
    this.addEventListener("input", this._updateTotal);

    this._updateTotal();
    this._attachFormListener();
  }

  _attachFormListener() {
    const form = document.querySelector("form[is='product-form']");
    if (!form) {
      console.log("Product form not found");
      return;
    }
    // Store ref so we can remove it later
    this._form = form;
    form.addEventListener("submit", this._handleBundleSubmit, true);
    console.log("Bundle submit listener attached");
  }

  _onDelegatedClick(e) {
    if (e.target.closest("[data-plus]") || e.target.closest("[data-minus]")) {
      // ✅ Small delay lets the stepper component update the input value first
      setTimeout(() => this._updateTotal(), 0);
    }
  }

  _updateTotal() {
    const totalEl = this.querySelector("[data-bundle-total]");
    const maxTotal = Number(this.getAttribute("data-max") || Infinity);
    const productContainer = this.closest("product-rerender");
    const submitBtn = productContainer?.querySelector(".buy-buttons [type='submit']");

    let total = 0;

    // ✅ Re-query rows fresh every time
    this.querySelectorAll("[data-bundle-row]").forEach(row => {
      const input = row.querySelector("[data-input]");
      total += Number(input?.value || 0);
    });

    if (totalEl) totalEl.textContent = total;

    // Plus button logic
    this.querySelectorAll("[data-plus]").forEach(btn => {
      if (total >= maxTotal) {
        btn.disabled = true;
      } else {
        const row = btn.closest("[data-bundle-row]");
        const input = row?.querySelector("[data-input]");
        const itemValue = Number(input?.value || 0);
        const itemMax = Number(input?.getAttribute("max") ?? Infinity);
        btn.disabled = itemValue >= itemMax;
      }
    });

    if (submitBtn) {
      submitBtn.disabled = total < maxTotal;
    }
  }

  async handleBundleSubmit(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const items = [];

    // ✅ Re-query fresh at submit time
    this.querySelectorAll("[data-bundle-row]").forEach((row) => {
      const qtyInput = row.querySelector("[data-input]");
      const variantInput = row.querySelector("[data-input-id]");

      const quantity = Number(qtyInput?.value || 0);
      const variantId = Number(variantInput?.value);

      if (quantity > 0 && variantId) {
        items.push({ id: variantId, quantity });
      }
    });

    console.log("items:", items);
    if (!items.length) return;

    const productContainer = this.closest("product-rerender");
    const submitBtn = productContainer?.querySelector(".buy-buttons [type='submit']");

    try {
      if (submitBtn) {
        submitBtn.setAttribute("aria-busy", "true");
        submitBtn.disabled = true;
      }

      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      await res.json();

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );

    } catch (e) {
      console.error(e);

    } finally {
      if (submitBtn) {
        submitBtn.removeAttribute("aria-busy");
        submitBtn.disabled = false;
      }

      setTimeout(() => {
        if (typeof handleFloCartBtn === "function") handleFloCartBtn();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
      }, 2000);
    }
  }

  disconnectedCallback() {
    this.removeEventListener("input", this._updateTotal);

    if (this._form) {
      this._form.removeEventListener("submit", this._handleBundleSubmit, true);
    }
  }
}

customElements.define("bundle-container", BundleContainer);

if(document.querySelector('.product-offers.swiper')) {
  const offersSwiper = new Swiper('.product-offers.swiper', {
    slidesPerView: 'auto',
    spaceBetween: 8,
    freeMode: true,
    grabCursor: true,
    watchOverflow: true,
  });
}

document.addEventListener("click", function (e) {
  const button = e.target.closest(".offer-card__copy");
  if (!button) return;

  const code = button.dataset.copy;
  navigator.clipboard.writeText(code);

  button.classList.add("is-active");

  setTimeout(() => {
    button.classList.remove("is-active");
  }, 2000);
});


// Mute all videos + reset buttons
function muteAllVideos() {
  const activeButtons = document.querySelectorAll('.mute-icon.active');

  activeButtons.forEach(btn => {
    const slide = btn.closest('.inner__slide');
    const video = slide && slide.querySelector('video');

    if (video) video.muted = true;
    btn.classList.remove('active');
  });
}

// Handle mute button clicks
const muteButtons = document.querySelectorAll('.mute-icon');

if (muteButtons.length) {
  muteButtons.forEach(btn => {
    btn.addEventListener('click', () => {
     
      const slide = btn.closest('.inner__slide');
      const video = slide && slide.querySelector('video');
      const btn_Second = slide && slide.querySelector('.mute-icon');

      if (!video) return;

      if(btn_Second.classList.contains('active')) {
        video.muted = true; 
        btn.classList.remove('active');
      } else {
        muteAllVideos();
        video.muted = false; 
        btn.classList.add('active');
      }
    });
  });
}

// Swiper slide change handling
if (window.Swiper) {
  const swipers = document.querySelectorAll('.swiper');

  swipers.forEach(swiperEl => {
    const instance = swiperEl && swiperEl.swiper;

    if (instance && instance.on) {
      instance.on('slideChange', () => {
        muteAllVideos();
      });
    }
  });
}

// Drawer open observer
const observer = new MutationObserver(() => {
  const drawerOpen = document.querySelector('.drawer[open]');

  if (drawerOpen) {
    muteAllVideos();
  }
});

observer.observe(document.body, {
  attributes: true,
  subtree: true,
  attributeFilter: ['class']
});

// Intersection observer (mute when out of view)
const sections = document.querySelectorAll('.inner__slide');

const io = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      const video = entry.target.querySelector('video');
      const btn = entry.target.querySelector('.mute-icon.active');

      if (video) video.muted = true;
      if (btn) btn.classList.remove('active');
    }
  });
}, { threshold: 0.3 });

sections.forEach(section => {
  if (section) io.observe(section);
});




// document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll(".js-marquee").forEach(function (marquee) {

//     const direction = marquee.dataset.direction;
//     const speed = 0.5; // lower = slower

//     let position = 0;

//     // duplicate content once
//     marquee.innerHTML += marquee.innerHTML;

//     const isVertical = direction === "vertical";

//     const getSize = () => {
//       return isVertical
//         ? marquee.scrollHeight / 2
//         : marquee.scrollWidth / 2;
//     };

//     let size = getSize();

//     function animate() {
//       position += speed;

//       if (position >= size) {
//         position = 0;
//       }

//       if (isVertical) {
//         marquee.style.transform = `translateY(-${position}px)`;
//       } else {
//         marquee.style.transform = `translateX(-${position}px)`;
//       }

//       requestAnimationFrame(animate);
//     }

//     animate();

//     // Recalculate on resize
//     window.addEventListener("resize", function () {
//       size = getSize();
//     });

//   });

// });


document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".js-marquee").forEach(function (marquee) {

    const isVertical = marquee.dataset.direction === "vertical";
    const flip = marquee.dataset.flip === "true";
    const speed = 0.5;

    let position;

    // 🔥 REMOVE ALL WHITESPACE BETWEEN IMAGES (fixes your gap)
    removeWhitespaceNodes(marquee);

    // duplicate content
    marquee.innerHTML += marquee.innerHTML;

    const getSize = () => {
      return isVertical
        ? marquee.scrollHeight / 2
        : marquee.scrollWidth / 2;
    };

    let size = getSize();

    // If flipped (right → left), start at end
    position = flip ? -size : 0;

    function animate() {
      // update position
      position += flip ? speed : -speed;

      // loop seamlessly
      if (position <= -size) position = 0;
      if (position >= 0) position = -size;

      // transform
      marquee.style.transform = isVertical ? `translateY(${position}px)` : `translateX(${position}px)`;

      requestAnimationFrame(animate);
    }

    animate();

    window.addEventListener("resize", () => {
      size = getSize();
    });

  });

});

function removeWhitespaceNodes(el) {
  [...el.childNodes].forEach(node => {
    if (node.nodeType === 3 && !/\S/.test(node.nodeValue)) {
      node.remove(); // remove empty text nodes
    }
  });
}

document.querySelectorAll('.menu-tab-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    const id = this.getAttribute('data-tab-id');

    document.querySelectorAll('.menu-tab-btn').forEach(b => b.removeAttribute('data-active'));
    this.setAttribute('data-active', 'true');

    document.querySelectorAll('.menu-tab-panel').forEach(panel => {
      panel.hidden = panel.id !== id;
    });
  });
});


const container = document.querySelector(".mega-menu-swiper .swiper-wrapper");
const cards = container.querySelectorAll(".swiper-slide");
const cardWidth = 260; // FIXED WIDTH you set above

const containerWidth = container.parentElement.offsetWidth;
const visibleCount = Math.floor(containerWidth / cardWidth);
const totalCards = cards.length;

// If collection count <= visible cards → NO SWIPER
if (totalCards <= visibleCount) {
  document.querySelector(".mega-menu-swiper").classList.add("no-swiper");// Do NOT initialize Swiper
}

// Otherwise initialize Swiper with fixed width slides
new Swiper(".mega-menu-swiper", {
  slidesPerView: "auto",
  spaceBetween: 24,
  mousewheel: {
    forceToAxis: true,
    sensitivity: 0.3,       
    releaseOnEdges: true,
    thresholdDelta: 20,     
    thresholdTime: 100     
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const images = document.querySelectorAll(".synced-gif");
//   let loadedCount = 0;

//   images.forEach((img) => {
//     const temp = new Image();
//     temp.src = img.src;

//     temp.onload = () => {
//       loadedCount++;
//       if (loadedCount === images.length) {
//         images.forEach(i => i.style.visibility = "visible");
//       }
//     };
//   });
// });


// search js start

(function () {
  const STORAGE_KEY = 'search_recent';
  const MAX_ITEMS = 6;

  function getRecent() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch { return []; }
  }

  function saveRecent(terms) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(terms));
  }

  function addSearch(term) {
    if (!term || term.trim().length < 2) return;
    let terms = getRecent();
    terms = terms.filter(t => t.toLowerCase() !== term.toLowerCase());
    terms.unshift(term.trim());
    terms = terms.slice(0, MAX_ITEMS);
    saveRecent(terms);
  }

  function renderRecent() {
    const wrapper = document.getElementById('recent-searches-wrapper');
    const list = document.getElementById('recent-searches-list');
    if (!wrapper || !list) return;

    const terms = getRecent();
    if (terms.length === 0) {
      wrapper.style.display = 'none';
      return;
    }

    wrapper.style.display = '';
    list.innerHTML = terms.map(term => `
      <li>
        <a href="/search?q=${encodeURIComponent(term)}">${term}</a>
      </li>
    `).join('');
  }

  function initListeners() {
    const searchInput = document.querySelector('search-drawer input[name="q"]');
    if (!searchInput) return;

    let saveTimeout;

    // Save while typing (debounced) — triggers when predictive search fires
    searchInput.addEventListener('input', () => {
      const term = searchInput.value.trim();
      clearTimeout(saveTimeout);

      if (term.length >= 2) {
        saveTimeout = setTimeout(() => {
          addSearch(term);
          renderRecent();
        }, 800);
      }
    });

    // Save on form submit (enter key)
    const form = searchInput.closest('form');
    if (form) {
      form.addEventListener('submit', () => {
        clearTimeout(saveTimeout);
        const term = searchInput.value.trim();
        if (term) {
          addSearch(term);
          renderRecent();
        }
      });
    }

    // Save when clicking a predictive suggestion link
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.predictive-search a');
      if (link) {
        const text = link.textContent.trim();
        if (text) {
          addSearch(text);
          renderRecent();
        }
      }
    });
  }

  // Re-render recent searches when drawer opens
  const drawer = document.getElementById('search-drawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      renderRecent();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initListeners();
      renderRecent();
    });
  } else {
    initListeners();
    renderRecent();
  }

})();




// function initSearchSwiper() {
//   const slider = document.querySelector(".search_slider_product");

//   if (!slider) return;

//   // Mobile: destroy swiper if exists
//   if (window.innerWidth < 768) {
//     if (slider.swiper) {
//       slider.swiper.destroy(true, true);
//     }
//     return;
//   }

//   // Desktop: initialize swiper
//   if (slider.swiper) return;

//   new Swiper(slider, {
//     grabCursor: true,
//     slidesPerView: "auto",
//     spaceBetween: 8,
//     speed: 600,
//     freeMode: true
//   });
// }
// window.addEventListener('resize', initSearchSwiper);
// function initSearchSwiper2() {
//   const slider = document.querySelector(".search_slider_col");

//   if (!slider || slider.swiper) return;

//   new Swiper(slider, {
//     grabCursor: true,
//     slidesPerView: 6.2,
//     spaceBetween: 8,
//     speed: 600,
//     slidesOffsetAfter: 0,
//     freeMode: true,
//     breakpoints: {
//       375: {
//         slidesPerView: 3.5,
//         spaceBetween: 8
//       },
//       767: {
//         slidesPerView:  5.2,
//         spaceBetween: 8
//       }
//     }
//   });
// }
// // Watch search drawer for dynamic content updates
// const searchDrawer = document.querySelector("#search-drawer");

// if (searchDrawer) {
//   const observer = new MutationObserver(() => {
//     initSearchSwiper();
//     initSearchSwiper2();
//   });

//   observer.observe(searchDrawer, {
//     childList: true,
//     subtree: true
//   });
// }



document.addEventListener('click', function (e) {
  const buyButton = e.target.closest('.search_slider_section .product-card__quick-buy button');

  if (!buyButton) return;

  setTimeout(() => {
    const searchDrawer = document.querySelector('.search-drawer');

    if (searchDrawer) {
      searchDrawer.style.zIndex = '0';
    }
  }, 2000);
});

// Restore when search opens again
document.querySelectorAll('[aria-controls*="search"], .search-toggle').forEach(btn => {
  btn.addEventListener('click', () => {
    const searchDrawer = document.querySelector('.search-drawer');
    if (searchDrawer) {
      searchDrawer.style.zIndex = '';
    }
  });
});